import { render, staticRenderFns } from "./NewsAndNoticeList.vue?vue&type=template&id=34b0858e&scoped=true&"
import script from "./NewsAndNoticeList.vue?vue&type=script&lang=js&"
export * from "./NewsAndNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndNoticeList.vue?vue&type=style&index=0&id=34b0858e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0858e",
  null
  
)

export default component.exports